import { orderBy } from 'lodash';

export default {
  computed: {
    promo_product() {
      return this.$store.getters[`${this.store}/promo_product`];
    },
    parts() {
      if (!this.promo_product.parts) {
        return [];
      }
      return orderBy(
        this.promo_product.parts.filter((x) => x.isAvailable),
        ['isAvailable', 'name'],
        ['desc', 'asc']
      );
    },
    part() {
      const editItem = this.$store.getters[`${this.store}/edit_item`];
      return this.parts.find((x) => x.id === editItem.partId) || {};
    },
    locations() {
      if (this.part) {
        return this.part.locations || [];
      }
      return [];
    },
    location() {
      const editItem = this.$store.getters[`${this.store}/edit_item`];
      return this.locations.find((x) => x.id === editItem.locationId) || {};
    },
    decorations() {
      if (this.location) {
        return this.location.decorations || [];
      }
      return [];
    },
    decoration() {
      const editItem = this.$store.getters[`${this.store}/edit_item`];
      return this.decorations.find((x) => x.id === editItem.decorationId);
    },
    decoration_colors() {
      if (!this.decoration) {
        return [];
      }
      const colors = (this.decoration.colors || [])
        .filter((x) => !x.name.includes('Custom') && !x.name.includes('Unknown'))
        .map((x) => Object.assign(x, { isFull: x.name === 'Full Color' }));
      return orderBy(colors, ['isFull', 'name'], ['desc', 'asc']);
    },
    decoration_color() {
      const editItem = this.$store.getters[`${this.store}/edit_item`];
      return this.decoration_colors.find((x) => x.id === editItem.decorationColorId);
    }
  },
  methods: {}
};
